<template>
  <div @click.prevent="approved = !approved" :class="{ 'btn': true, 'btn-white': !approved, 'btn-primary': approved }">
    <div class="">
      <input type="checkbox" 
        :id="`approve_insight_${id}`" 
        class=""
        v-model="approved">
      <label class="d-none d-md-inline ml-1" :for="`approve_insight_${id}`">
        {{ approved ? 'Approved' : 'Pending' }}
      </label>
    </div>
  </div>
</template>

<script>
import alertify from 'alertify.js'
import axios from 'axios'

export default {
  name: 'approve-insight-button',
  props: {
    id: Number
  },
  data () {
    return {
      approved: false
    }
  },
  watch: {
    approved () {
      if (this.approved) {
        this.approve()
      } else {
        this.undo()
      }
    }
  },
  methods: {
    approve () {
      axios.post(`/pages/insights/${this.id}/approved`).then(() => {
        alertify.closeLogOnClick().log('Saved. <a href="#" class="text-primary ml-2 text-underline">UNDO</a>', () => {
          this.approved = false
        })
      }).catch(() => {
        alertify.error('Failed to save approval.')
      })
    },
    undo () {
      axios.delete(`/pages/insights/${this.id}/approved`).then(() => {
        this.approved = false
        alertify.log('Undone.')
      }).catch(() => {
        alertify.error('Failed to undo approval.')
      })
    }
  }
}
</script>